import React from 'react';
import styles from './StaffMember.module.scss';
import api from '../../../helpers/api';
import Tooltip from '../../../components/miscellaneous/Tooltip/Tooltip';
import StaffDelete from '../../../components/clinic/StaffDelete/StaffDelete';

import {FaEdit} from 'react-icons/fa';
import {FiUsers} from 'react-icons/fi';
import {GiRadiations, GiElectric} from 'react-icons/gi';
import {BsGraphUp} from 'react-icons/bs';
import {CgMathDivide} from 'react-icons/cg';
import moment from 'moment';
import TimePeriodSelector from '../../../components/miscellaneous/TimePeriodSelector/TimePeriodSelector';
import Loader from '../../../components/miscellaneous/Loader/Loader';
import MultiSelect from '../../../components/miscellaneous/MultiSelect/MultiSelect';
import {$t} from '../../../helpers/translator';
import Modal from '../../../components/miscellaneous/Modal/Modal';

import TreatmentsTable from "../../../components/TreatmentsTable/TreatmentsTable";
import StaffMemberAdd from "../../../components/StaffMemberAdd/StaffMemberAdd";
import {ResponsivePieCanvas} from "@nivo/pie";


class ClinicStaffMember extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id ? this.props.match.params.id : null,
            staff: null,
            staffExists: true,
            editStaffVisible: false,
            treatmentTypesAndAreas: null,

            dataTableParameters: {
                staffId: this.props.match.params.id ? this.props.match.params.id : null,
                page: 1,
                sorted: {
                    id: 'created_at',
                    desc: true
                },
                startDate: moment().subtract(1, 'weeks'),
                endDate: moment(),
                patientId: null,
                areaId: null,
            },
            dataTableParameterAreaSelected: {
                value: null,
                label: $t('global.staff.allAreas')
            },

            sessions: null,
            pagination: null,
        };
    }

    async componentDidMount() {
        // console.log('>>>>>', this.props)

        // await this.getTreatmentTypesAndAreas();
        await this.getStaff();
        // await this.getSessions();
    }

    async getStaff() {
        try {
            let res2 = await api.get(`/staff/${this.state.id}`);

            if (res2 && res2.data && res2.data.data) {
                this.setState({staff: res2.data.data}, () => {
                    // this.renderPieChart();
                    // console.log('this.statte', this.state);
                });
            } else {
                this.setState({staffExists: false})
            }
        } catch (e) {
            console.error('err getting staff', e);
        }
    }


    toggleStaffModalShow = () => {
        this.setState({editStaffVisible: !this.state.editStaffVisible});
    };


    staffDeletedHandler() {
        this.props.history.push('/staff');
    }

    tableActionHandler(data) {
        if (!data || !data.key) {
            return;
        }

        let dataTableParameters = {...this.state.dataTableParameters};

        switch (data.key) {
            case 'page':
                //page transition:
                dataTableParameters.page = data.value;
                this.setState({dataTableParameters: dataTableParameters}, async () => {
                    await this.getSessions();
                });
                break;

            case 'header':
                //sorting table by key
                let currentSort = this.state.dataTableParameters.sorted;
                let newSort = null;

                if (!currentSort || (currentSort.id && currentSort.id !== data.value)) {
                    newSort = {
                        id: data.value,
                        desc: false
                    };
                } else {
                    newSort = {
                        id: data.value,
                        desc: !currentSort.desc
                    };
                }

                dataTableParameters.sorted = newSort;

                this.setState({dataTableParameters: dataTableParameters}, async () => {
                    await this.getSessions();
                });
                break;
            default:
        }
    }

    datesChangeHandler = (timePeriod) => {
        let dataTableParameters = {...this.state.dataTableParameters};
        dataTableParameters.startDate = timePeriod.startDate;
        dataTableParameters.endDate = timePeriod.endDate;

        this.setState({dataTableParameters: dataTableParameters}, async () => {
            await this.getSessions();
        });
    };

    filterChangedHandler(id, event) {
        let dataTableParameters = {...this.state.dataTableParameters};
        let dataTableParameterAreaSelected = {...this.state.dataTableParameterAreaSelected};
        // console.log('ddd', id, event)

        if (id === 'areaId') {
            dataTableParameters.areaId = event.value;
            dataTableParameterAreaSelected = event;
        } else {
            dataTableParameters[id] = event.target.value;
        }
        // dataTableParameters[id] = id === 'areaId' ? event.value : event.target.value;

        this.setState({
            dataTableParameters: dataTableParameters,
            dataTableParameterAreaSelected: dataTableParameterAreaSelected
        }, async () => {
            await this.getSessions();
            // console.log('newstat:', this.state);
        });
    }

    renderStaffDetailsBlock() {
        let staff = this.state.staff && this.state.staff.details ? this.state.staff.details : null;
        if (!staff) {
            return;
        }

        return (
            <div>
                <div className={`${styles['header-row']}`}>
                    <span><h3>{$t('global.staff.generalDetails')}</h3></span>
                    {staff && this.state.id !== '-1' && !staff.deleted_at ?
                        <div className={`${styles['top-icons-container']}`}>
                            <Tooltip content={$t('global.staff.editStaffDetails')}>
                                <FaEdit onClick={() => this.toggleStaffModalShow()} style={{fontSize: '23px'}}
                                        className={`${styles['click-cursor']}`}/>
                            </Tooltip>
                            <Tooltip content={$t('global.staff.StaffDeleteMember')}>
                                <StaffDelete id={this.state.id} patientName={staff.name} patientId={staff.personalId}
                                             style={{
                                                 fontSize: '25px',
                                                 margin: '0 15px'
                                             }}
                                             onSuccess={() => this.staffDeletedHandler()}/>
                            </Tooltip>
                        </div>
                        :
                        null
                    }
                </div>
                {
                    staff ?
                        <div className={`${styles['staff-details-content']}`}>
                            <div className={`${styles['detail-container']}`}>
                                <div className={`${styles['detail-header']}`}>{$t('global.staff.staffId')}</div>
                                <div className={`${styles['detail-value']}`}>{staff.personalId}</div>
                            </div>
                            <div className={`${styles['detail-container']}`}>
                                <div className={`${styles['detail-header']}`}>{$t('global.staff.staffName')}</div>
                                <div className={`${styles['detail-value']}`}>{staff.name}</div>
                            </div>
                            <div className={`${styles['detail-container']}`}>
                                <div className={`${styles['detail-header']}`}>Email</div>
                                <div className={`${styles['detail-value']}`}>{staff.email}</div>
                            </div>
                            <div className={`${styles['detail-container']}`}>
                                <div className={`${styles['detail-header']}`}>{$t('global.staff.joinedAt')}</div>
                                <div className={`${styles['detail-value']}`}>{moment(staff.joindAt).format('LL')}</div>
                            </div>
                            <div className={`${styles['detail-container']}`}>
                                <div className={`${styles['detail-header']}`}>{$t('global.staff.lastTreatment')}</div>
                                <div
                                    className={`${styles['detail-value']}`}>{staff.lastSession ? moment(staff.lastSession).format('LL') : '-'}</div>
                            </div>
                        </div>
                        :
                        <Loader/>
                }
            </div>
        );
    }

    patientEditSuccessHandler(data) {
        // console.log('>>>>', data);
        let staff = {...this.state.staff};

        staff.details.name = data.staff.name;
        staff.details.personalId = data.staff.personalId;

        this.setState({staff: staff})
    }

    renderEditStaffModal() {
        // console.log('this.astt', this.state)
        return (
            <div>
                {
                    this.state.staff && this.state.staff.details ?
                        <div>
                            <Modal content={<div><StaffMemberAdd mode="edit"
                                                                 visible={true}
                                                                 staff={this.state.staff.details ? this.state.staff.details : null}
                                                                 emitClose={async () => {
                                                                     this.toggleStaffModalShow();
                                                                     await this.getStaff()
                                                                 }}
                            /></div>}
                                   onClose={this.toggleStaffModalShow}
                                   visible={this.state.editStaffVisible}/>
                        </div>

                        :
                        null
                }
            </div>
        );
    }

    renderFilters() {
        return (
            <div className={`${styles['filters-row']}`}>
                <div className={`${styles['field-input']}`}>
                    <TimePeriodSelector startDate={this.state.dataTableParameters.startDate}
                                        endDate={this.state.dataTableParameters.endDate}
                                        hideQuarters
                                        styles={{height: '38px'}}
                                        onDatesChange={this.datesChangeHandler}/>
                </div>

                <div className={`${styles['field-input']}`}>
                    <input name="patientId"
                           className={'alma-input'}
                           type="text"
                           value={this.state.dataTableParameters && this.state.dataTableParameters.patientId ? this.state.dataTableParameters.patientId : ''}
                           placeholder={$t('global.staff.searchTreatmentsByPatientId')}
                           onChange={(e) => this.filterChangedHandler('patientId', e)}/>

                </div>
                <div className={`${styles['field-input']}`}>
                    {this.state.treatmentTypesAndAreas ?
                        <MultiSelect
                            options={this.state.treatmentTypesAndAreas}
                            selected={this.state.dataTableParameterAreaSelected}
                            placeholder={$t('global.staff.showingAllAreas')}
                            onValueChange={(e) => this.filterChangedHandler('areaId', e)}
                        />
                        :
                        null}
                </div>
            </div>
        );
    }

    renderStatisticsData() {
        let data = [
            {
                header: $t('global.staff.treatments'),
                valueRoute: 'treatments_count',
                hoverText: $t('global.staff.treatmentsExplained'),
                icon: <BsGraphUp/>
            },
            {
                header: $t('global.staff.patients'),
                valueRoute: 'patients_count',
                hoverText: $t('global.staff.patientsExplained'),
                icon: <FiUsers/>
            },
            {
                header: $t('global.staff.fluenceAccuracy'),
                valueRoute: 'fluence_accuracy',
                hoverText: $t('global.staff.fluenceAccuracyExplained'),
                icon: <GiRadiations/>
            },
            {
                header: $t('global.staff.energyAccuracy'),
                valueRoute: 'energy_accuracy',
                hoverText: $t('global.staff.energyAccuracyExplained'),
                icon: <GiElectric/>
            },
            {
                header: $t('global.staff.treatmentsPerPatient'),
                valueRoute: 'average_sessions',
                hoverText: $t('global.staff.treatmentsPerPatientExplained'),
                icon: <CgMathDivide/>
            },
        ];

        // let graphData = this.state.staff.pieChart;
        // console.log('graphData', this.state.staff.pieChart)

        let graphData = [
            {
                "id": $t('global.staff.preparation'),
                "label": "preperation_time",
                "value": this.state.staff.pieChart.preperation_time,
            },
            {
                "id": $t('global.staff.treatment'),
                "label": "overall_time",
                "value": this.state.staff.pieChart.overall_time,
            }
        ]
        // return (<div>d</div>)


        return (
            <div className={`${styles['flex-row']}`}>
                <div>
                    <table style={{padding: '10px'}}>
                        <tbody>
                        {data.map((v, k) => (
                            <tr className={`${styles['statistics-row']}`} key={k}>
                                <td className={`${styles['statistics-icon']}`}>
                                    {/*<Tooltip content={v.hoverText}>{v.icon}</Tooltip>*/}
                                    {v.icon}
                                </td>
                                <td className={`${styles['statistics-header']}`}>
                                    <Tooltip content={v.hoverText}>{v.header}:</Tooltip>
                                </td>
                                <td className={`${styles['statistics-value']}`}>{this.state.staff[v.valueRoute]}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                <div id="pie-chart-container" style={{
                    height: '250px',
                    width: '250px'
                }}>

                    <div className={styles.graphContainer}
                         style={{maxWidth: '100%', maxHeight: '100%'}}>
                        <ResponsivePieCanvas
                            data={graphData}
                            margin={{top: 40, right: 40, bottom: 40, left: 40}}
                            innerRadius={0.6}
                            padAngle={0.7}
                            cornerRadius={5}
                            activeOuterRadiusOffset={8}
                            colors={[
                                '#93d5ed',
                                // '#5c9ceb',
                                // '#2e7de4',
                                '#1d5ba6',
                            ]}
                            borderColor="#000000"

                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#333333"
                            arcLinkLabelsThickness={2}
                            arcLinkLabelsColor={{from: 'color'}}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor="#333333"
                            defs={[
                                {
                                    id: 'dots',
                                    type: 'patternDots',
                                    background: 'inherit',
                                    color: 'rgba(255, 255, 255, 0.3)',
                                    size: 4,
                                    padding: 1,
                                    stagger: true
                                },
                                {
                                    id: 'lines',
                                    type: 'patternLines',
                                    background: 'inherit',
                                    color: 'rgba(255, 255, 255, 0.3)',
                                    rotation: -45,
                                    lineWidth: 6,
                                    spacing: 10
                                }
                            ]}

                            legends={[
                                {
                                    anchor: 'bottom-right',
                                    // anchor: parseInt(windowWidth) < 1024 ? 'bottom' : 'right',
                                    direction: 'column',
                                    justify: false,
                                    translateX: 140,
                                    translateY: 0,
                                    itemsSpacing: 2,
                                    itemWidth: 60,
                                    itemHeight: 14,
                                    itemTextColor: '#999',
                                    itemDirection: 'left-to-right',
                                    itemOpacity: 1,
                                    symbolSize: 14,
                                    symbolShape: 'circle'
                                }
                            ]}
                        />
                    </div>

                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.state.staffExists ?
                    <div>
                        <div className={'alma-box'}>
                            <div>
                                {this.renderEditStaffModal()}
                                {this.renderStaffDetailsBlock()}
                            </div>
                        </div>

                        {this.props.match.params.id && this.props.match.params.id === -1 ?
                            null
                            :
                            <div className={'alma-box'}>
                                <div className={'alma-box-header'}>
                                    <div><h3>{$t('global.staff.statistics')}</h3></div>
                                </div>
                                {this.state.staff ? this.renderStatisticsData() : <Loader/>}
                            </div>
                        }

                        <TreatmentsTable userType={2} staffId={this.props.match.params.id}
                                         header={$t('global.staff.staffsTreatments')}/>
                    </div>
                    :
                    <div>
                        Couldn't find staff member
                    </div>
                }

            </div>
        );
    }
}

export default ClinicStaffMember;
